import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat.js'
dayjs.extend(customParseFormat)
export function parseDateInput(value) {
  const date = dayjs(value, 'DD-MM-YYYY', true)
  return date.isValid() ? date.format('YYYY-MM-DD') : null
}
